import React from 'react'

const Blog = () => {
    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header">
                <div className="page-header__bg" style={{backgroundImage: "url(/assets/images/backgrounds/page-header-img1.jpg)"}}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper">
                                <div className="page-header__content">
                                    <h2>Blog Post</h2>
                                    <div className="page-header__menu">
                                        <ul>
                                            <li><a hreflang="en" href="/">Home</a></li>
                                            <li>Blog</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}



            {/* <!--Start Blog Page Two--> */}
            <section className="blog-page-two">
                <div className="container">
                    <div className="row">
                        {/* <!--Start Blog Page Two Content--> */}
                        <div className="col-xl-8 col-lg-7">
                            <div className="blog-page-two__content">

                                {/* <!--Start Blog Page Two Single--> */}
                                <div className="blog-page-two__single">
                                    <div className="blog-page-two__single-img">
                                        <img src="/assets/images/blog/blog-page-v2-img1.jpg" alt="" />
                                    </div>

                                    <div className="blog-page-two__single-content">
                                        <div className="blog-page-two__single-title">
                                            <p className="blog-page-two__single-tagline">HARDWOOD FLOORING</p>
                                            <h2 className="blog-page-two__single-headding"><a hreflang="en" href="/Blog-Details">Expert
                                                Advice on Hardwood
                                                Floors for Homeowners</a></h2>
                                        </div>
                                        <ul className="blog-page-two__single-meta-info">
                                            <li><i className="fa fa-calendar" aria-hidden="true"></i>June 27, 2021</li>
                                            <li><i className="fa fa-eye" aria-hidden="true"></i>457 Views</li>
                                        </ul>
                                        <p className="blog-page-two__single-text">Hardwood flooring is the most popular flooring
                                            in North America; followed very closely by wood floor look a-likes such as
                                            porcelain tile and luxury vinyl plank</p>

                                        <div className="blog-page-two__single-btn">
                                            <a hreflang="en" href="/Blog-Details">Reading <img src="/assets/images/icon/right-arrow.png" alt="" /></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End Blog Page Two Single--> */}


                                {/* <!--Start Blog Page Two Single--> */}
                                <div className="blog-page-two__single">
                                    <div className="blog-page-two__single-img">
                                        <img src="/assets/images/blog/blog-page-v2-img2.jpg" alt="" />
                                    </div>

                                    <div className="blog-page-two__single-content">
                                        <div className="blog-page-two__single-title">
                                            <p className="blog-page-two__single-tagline">HARDWOOD FLOORING</p>
                                            <h2 className="blog-page-two__single-headding"><a hreflang="en" href="/Blog-Details">The
                                                Importance of a
                                                Succession Plan for Your Flooring Business</a></h2>
                                        </div>
                                        <ul className="blog-page-two__single-meta-info">
                                            <li><i className="fa fa-calendar" aria-hidden="true"></i>June 27, 2021</li>
                                            <li><i className="fa fa-eye" aria-hidden="true"></i>457 Views</li>
                                        </ul>
                                        <p className="blog-page-two__single-text">Hardwood flooring is the most popular flooring
                                            in North America; followed very closely by wood floor look a-likes such as
                                            porcelain tile and luxury vinyl plank</p>

                                        <div className="blog-page-two__single-btn">
                                            <a hreflang="en" href="/Blog-Details">Reading <img src="/assets/images/icon/right-arrow.png" alt="" /></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End Blog Page Two Single--> */}


                                {/* <!--Start Blog Page Two Single--> */}
                                <div className="blog-page-two__single">
                                    <div className="blog-page-two__single-img">
                                        <img src="/assets/images/blog/blog-page-v2-img3.jpg" alt="" />
                                    </div>

                                    <div className="blog-page-two__single-content">
                                        <div className="blog-page-two__single-title">
                                            <p className="blog-page-two__single-tagline">HARDWOOD FLOORING</p>
                                            <h2 className="blog-page-two__single-headding"><a hreflang="en" href="/Blog-Details">Digital
                                                Brand Protection
                                                Tips Every Business Owner </a></h2>
                                        </div>
                                        <ul className="blog-page-two__single-meta-info">
                                            <li><i className="fa fa-calendar" aria-hidden="true"></i>June 27, 2021</li>
                                            <li><i className="fa fa-eye" aria-hidden="true"></i>457 Views</li>
                                        </ul>
                                        <p className="blog-page-two__single-text">Hardwood flooring is the most popular flooring
                                            in North America; followed very closely by wood floor look a-likes such as
                                            porcelain tile and luxury vinyl plank</p>

                                        <div className="blog-page-two__single-btn">
                                            <a hreflang="en" href="/Blog-Details">Reading <img src="/assets/images/icon/right-arrow.png" alt="" /></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End Blog Page Two Single--> */}


                                {/* <!--Start Blog Page Two Single--> */}
                                <div className="blog-page-two__single">
                                    <div className="blog-page-two__single-img">
                                        <img src="/assets/images/blog/blog-page-v2-img4.jpg" alt="" />
                                    </div>

                                    <div className="blog-page-two__single-content">
                                        <div className="blog-page-two__single-title">
                                            <p className="blog-page-two__single-tagline">HARDWOOD FLOORING</p>
                                            <h2 className="blog-page-two__single-headding"><a hreflang="en" href="/Blog-Details">Bringing
                                                Stainmaster to
                                                the Tile Industry with The Tile Doctor</a></h2>
                                        </div>
                                        <ul className="blog-page-two__single-meta-info">
                                            <li><i className="fa fa-calendar" aria-hidden="true"></i>June 27, 2021</li>
                                            <li><i className="fa fa-eye" aria-hidden="true"></i>457 Views</li>
                                        </ul>
                                        <p className="blog-page-two__single-text">Hardwood flooring is the most popular flooring
                                            in North America; followed very closely by wood floor look a-likes such as
                                            porcelain tile and luxury vinyl plank</p>

                                        <div className="blog-page-two__single-btn">
                                            <a hreflang="en" href="/Blog-Details">Reading <img src="/assets/images/icon/right-arrow.png" alt="" /></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End Blog Page Two Single--> */}


                                <div className="row">
                                    <div className="col-xl-12">
                                        <ul className="styled-pagination clearfix">
                                            <li><a hreflang="en" href="#" className="active">1</a></li>
                                            <li><a hreflang="en" href="#">2</a></li>
                                            <li><a hreflang="en" href="#">3</a></li>
                                            <li><a hreflang="en" href="#">4</a></li>
                                            <li className="next"><a hreflang="en" href="#"><span className="fa fa-chevron-right"></span></a></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <!--End Blog Page Two Content--> */}


                        {/* <!--Start Sidebar--> */}
                        <div className="col-xl-4 col-lg-5">
                            <div className="sidebar">
                                {/* <!--Start Single Sidebar--> */}
                                <div className="sidebar__single sidebar__categories  wow fadeInUp animated"
                                    data-wow-delay="0.1s">
                                    <div className="title">
                                        <h2>Categories</h2>
                                    </div>
                                    <ul className="sidebar__categories-link">
                                        <li className="active"><a hreflang="en" href="#">Floor Installation <span>16</span></a>
                                        </li>
                                        <li><a hreflang="en" href="#">Refinishing <span>07</span></a></li>
                                        <li><a hreflang="en" href="#">Luxury Vinyl Plank <span>08</span></a></li>
                                        <li><a hreflang="en" href="#">Door Repair <span>04</span></a></li>
                                        <li><a hreflang="en" href="#">Interior Design <span>10</span></a></li>
                                    </ul>
                                </div>
                                {/* <!--End Single Sidebar--> */}


                                {/* <!--Start Single Sidebar--> */}
                                <div className="sidebar__single sidebar__popular-stories  wow fadeInUp animated"
                                    data-wow-delay="0.3s">
                                    <div className="title">
                                        <h2>Popular Stories</h2>
                                    </div>
                                    <ul className="sidebar__popular-stories-box">
                                        <li>
                                            <div className="img">
                                                <img src="/assets/images/resources/popular-stories-img1.png" alt="" />
                                            </div>

                                            <div className="text">
                                                <h4><a hreflang="en" href="#">The Evolution of <br /> Popular Wood Flooring <br /> Styles &
                                                    Types</a></h4>
                                                <p>Octobar 28, 2021</p>
                                            </div>
                                        </li>

                                        <li>
                                            <div className="img">
                                                <img src="/assets/images/resources/popular-stories-img2.png" alt="" />
                                            </div>

                                            <div className="text">
                                                <h4><a hreflang="en" href="#">The Importance of a <br />Succession Plan for <br />Your
                                                    Flooring Business</a></h4>
                                                <p>Octobar 28, 2021</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                {/* <!--End Single Sidebar--> */}


                                {/* <!--Start Single Sidebar--> */}
                                <div className="sidebar__single sidebar__contact-box wow fadeInUp animated"
                                    data-wow-delay="0.5s">

                                    <div className="services-single__sidebar-contact-info text-center">
                                        <div className="icon-bg"><img src="/assets/images/icon/phone.png" alt="" /></div>

                                        {/* <div className="icon">
                                            <span className="icon-wood-board"></span>
                                        </div> */}

                                        <h2 className="services-single__sidebar-contact-info-title">Quality Flooring at <br /> a
                                            Fair Price</h2>
                                        <p className="services-single__sidebar-contact-info-text">Call us for a FREE quote!</p>
                                        <a hreflang="en" href="tel:666888000">(501) 103-7840</a>
                                    </div>

                                </div>
                                {/* <!--End Single Sidebar--> */}
                            </div>
                        </div>
                        {/* <!--End Sidebar--> */}
                    </div>
                </div>
            </section>
            {/* <!--End Blog Page Two--> */}
    </>
  )
}

export default Blog